/* Layout */
import Layout from '@/views/layout/Layout'

export default [
  {
    path: '/protocolPage',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '平台协议管理',
      icon: 'email'
    },
    children: [
      {
        path: '/protocolPage/protocolList/:id',
        component: () => import('@/myviews/CI_protocolPage/protocolList/protocolList'),
        alwaysShow: false,
        hidden: true,
        name: '平台协议管理',
        meta: {
          title: '平台协议管理',
          icon: 'email',
          roles: ['add', 'modify', 'viewpage'],//添加   修改   查看页面
          have: []
        }
      },
      {
        path: '/protocolPage/protocolList/1',
        component: () => import('@/myviews/CI_protocolPage/protocolList/protocolList'),
        alwaysShow: false,
        name: '谷医堂健康',
        meta: {
          title: '谷医堂健康',
          icon: 'email',
          roles: ['add', 'modify', 'viewpage'],//添加   修改   查看页面
          have: []
        }
      },
      {
        path: '/protocolPage/protocolList/2',
        component: () => import('@/myviews/CI_protocolPage/protocolList/protocolList'),
        alwaysShow: false,
        name: '谷医堂医生',
        meta: {
          title: '谷医堂医生',
          icon: 'email',
          roles: ['add', 'modify', 'viewpage'],//添加   修改   查看页面
          have: []
        }
      },
      {
        path: '/protocolPage/protocolList/3',
        component: () => import('@/myviews/CI_protocolPage/protocolList/protocolList'),
        alwaysShow: false,
        name: '正糖名家',
        meta: {
          title: '正糖名家',
          icon: 'email',
          roles: ['add', 'modify', 'viewpage'],//添加   修改   查看页面
          have: []
        }
      },
      {
        path: '/protocolPage/protocolList/4',
        component: () => import('@/myviews/CI_protocolPage/protocolList/protocolList'),
        alwaysShow: false,
        name: '脂玫乐',
        meta: {
          title: '脂玫乐',
          icon: 'email',
          roles: ['add', 'modify', 'viewpage'],//添加   修改   查看页面
          have: []
        }
      },
      {
        path: '/protocolPage/protocolList/5',
        component: () => import('@/myviews/CI_protocolPage/protocolList/protocolList'),
        alwaysShow: false,
        name: '商城',
        meta: {
          title: '商城',
          icon: 'email',
          roles: ['add', 'modify', 'viewpage'],//添加   修改   查看页面
          have: []
        }
      },
      {
        path: '/protocolPage/protocolDetails',
        component: () => import('@/myviews/CI_protocolPage/protocolDetails/protocolDetails'),
        alwaysShow: false,
        hidden: true,
        name: '详情',
        meta: {
          title: '详情',
          icon: 'email',
          roles: ['add', 'modify', 'viewpage'],//添加   修改   查看页面
          have: []
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/systemManage/AH_protocolPage.js